// src/pdf-calcs/pdf-calcs-hltt.js
// HLTT Mass Calculator — DOM wiring. Recalculates immediately on load and on input change.

import { calculateHlttMass } from './hltt-calculations.js';
import { readNumeric, normalizeValue, formatFieldValue } from './pdf-calcs-utils.js';

// ---------------------------------------------------------------------------
// Field defaults and rules
// ---------------------------------------------------------------------------

const HLTT_DEFAULTS = {
   hlSteerAxleTareMass: 6.0,
   hlActualSteerAxleMass: 4.5,
   hlWheelbase: 8.0,
   hlRearAxleTareMass: 12.0,
   hlMaximumRearAxleLoad: 21.0,
   hlActualRearAxleLoad: 18.0,
   hlCouplingRearOverhang: 3.5,
};

const HLTT_FIELD_RULES = {
   hlSteerAxleTareMass: { min: 0, precision: 3, warningMax: 500 },
   hlActualSteerAxleMass: { min: 0, precision: 3, warningMax: 500 },
   hlWheelbase: { min: 0.001, precision: 3, warningMax: 50 },
   hlRearAxleTareMass: { min: 0, precision: 3, warningMax: 500 },
   hlMaximumRearAxleLoad: { min: 0, precision: 3, warningMax: 500 },
   hlActualRearAxleLoad: { min: 0, precision: 3, warningMax: 500 },
   hlCouplingRearOverhang: { min: 0.001, precision: 3, warningMax: 50 },
};

// ---------------------------------------------------------------------------
// Page initialisation
// ---------------------------------------------------------------------------

$(function () {
   const $page = $('#pdf-calcs-content');
   if ($page.length === 0) return;

   // Apply default values
   for (const [fieldId, value] of Object.entries(HLTT_DEFAULTS)) {
      $page.find(`[data-field="${fieldId}"]`).val(formatFieldValue(value, HLTT_FIELD_RULES[fieldId]));
   }

   // Initial calculation on page load
   calculateAndRender($page);

   // Recalculate on any field change
   $page.on('input change', '[data-field]', function () {
      calculateAndRender($page);
   });

   // Blur: normalise to min floor and fixed decimal precision
   $page.on('blur', '[data-field]', function () {
      const fieldId = $(this).data('field');
      const rule = HLTT_FIELD_RULES[fieldId];
      if (!rule) return;
      const val = normalizeValue(readNumeric($(this).val()), rule);
      $(this).val(formatFieldValue(val, rule));
   });

   // Reset all fields to their defaults
   $('#hltt-reset-defaults').on('click', function () {
      for (const [fieldId, value] of Object.entries(HLTT_DEFAULTS)) {
         $page.find(`[data-field="${fieldId}"]`).val(formatFieldValue(value, HLTT_FIELD_RULES[fieldId]));
      }
      calculateAndRender($page);
   });
});

// ---------------------------------------------------------------------------
// Calculation and result rendering
// ---------------------------------------------------------------------------

function calculateAndRender($page) {
   const input = {
      steerAxleTareMass: readNumeric($page.find('[data-field="hlSteerAxleTareMass"]').val()),
      actualSteerAxleMass: readNumeric($page.find('[data-field="hlActualSteerAxleMass"]').val()),
      wheelbase: readNumeric($page.find('[data-field="hlWheelbase"]').val()),
      rearAxleTareMass: readNumeric($page.find('[data-field="hlRearAxleTareMass"]').val()),
      maximumRearAxleLoad: readNumeric($page.find('[data-field="hlMaximumRearAxleLoad"]').val()),
      actualRearAxleLoad: readNumeric($page.find('[data-field="hlActualRearAxleLoad"]').val()),
      couplingRearOverhang: readNumeric($page.find('[data-field="hlCouplingRearOverhang"]').val()),
   };

   const result = calculateHlttMass(input);

   const $steerPct = $page.find('#hltt-result-steer-pct');
   const $maxLoad = $page.find('.hltt-result-max-load');
   const $swl = $page.find('#hltt-result-swl');
   const $ctl = $page.find('#hltt-result-ctl');

   if (result.ok) {
      const { steerAxlePercent, maximumLoad, safeWorkLoad, compliantTowLoad } = result.outputs;

      $steerPct.text(parseFloat(steerAxlePercent.toFixed(2)).toString()).removeClass('hltt-result--invalid');
      $maxLoad.text(parseFloat(maximumLoad.toFixed(3)).toString()).removeClass('hltt-result--invalid');
      $swl.text(parseFloat(safeWorkLoad.toFixed(3)).toString());
      $ctl.text(parseFloat(compliantTowLoad.toFixed(3)).toString());
   } else {
      $steerPct.text('—').addClass('hltt-result--invalid');
      $maxLoad.text('—').addClass('hltt-result--invalid');
      $swl.text('—');
      $ctl.text('—');
   }
}
